
import Vue from "vue";
import Component from "vue-class-component";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import { DuplicableDocumentModel, DuplicableDocumentModelDocumentType, StartApplyingOrChangeTypeClient, StartApplyingForDuplicateRequest, ChangeTypeToDuplicateRequest, } from "@/api-client";
import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
import { Prop } from "vue-property-decorator";
import { ls } from "@/CultureService";

const documentTypeTranslationsMap = {
    certificate: ls.Global_Label_Certificate,
    endorsement: ls.Global_Label_Endorsement
};

interface Props {
    documentType?: DuplicableDocumentModelDocumentType | null;
    seafarerId: string;
    applicationId?: string;
    duplicableDocuments: DuplicableDocumentModel[];
    btnClass: string;
}

@Component({
    components: {
        HeadingWave,
        SectionPageHeading,
        TableEmptySlot
    },
})
export default class DuplicateTypeTable extends Vue implements Props {
    @Prop({ required: false, default: null })
    documentType!: DuplicableDocumentModelDocumentType | null;
    @Prop({ required: true })
    seafarerId!: string;
    @Prop({ required: false })
    applicationId!: string;
    @Prop({ required: true })
    duplicableDocuments!: DuplicableDocumentModel[];
    @Prop({ required: false, default: 'btn-wide' })
    btnClass!: string;

    get filteredDuplicableDocuments(): DuplicableDocumentModel[] {
        return this.duplicableDocuments.filter(x => {
            if (!this.documentType)
                return true;

            return this.documentType == x.documentType;
        });
    }

    fields = [
        { key: 'documentNumber', label: this.$ls.Global_Label_DocumentNumber, sortable: true, thClass: 'w-10' },
        { key: 'name', label: this.$ls.Global_Label_CertificateTypeName, sortable: true },
        {
            key: 'documentType',
            label: this.$ls.Global_Label_DocumentType,
            sortable: true,
            sortByFormatted: true,
            formatter: (value: any, key: any, item: DuplicableDocumentModel) => {
                return documentTypeTranslationsMap[item.documentType]
            },
            thClass: 'w-15'
        },
        { key: 'linkIcon', label: '', sortable: false, thClass: 'w-20', tdClass: 'table-actions' }
    ];

    startApplyingOrChangeType(certificateOrEndorsementId: string) {
        if (this.applicationId) {
            const request = new ChangeTypeToDuplicateRequest({
                certificateOrEndorsementId,
                appId: this.applicationId
            });

            new StartApplyingOrChangeTypeClient().changeTypeToDuplicate(request, this.seafarerId)
                .then(() => this.$router.go(0));
        }
        else {
            const request = new StartApplyingForDuplicateRequest({ certificateOrEndorsementId });
            new StartApplyingOrChangeTypeClient().startApplyingForDuplicate(request, this.seafarerId)
                .then(result => this.$router.push({
                    name: "ApplicationOverview",
                    params: { applicationId: result.applicationId }
                }));
        }
    }
}
